import { redirect } from '@tanstack/react-router';
import { getAuthSnapshot } from './authSnapshot';

/**
 * Creates a route guard that redirects authenticated users to their dashboard
 *
 * Use this in route's `beforeLoad` to prevent authenticated users from accessing
 * the login page
 *
 * @example
 * ```tsx
 * export const Route = createFileRoute('/login')({
 *   component: LoginPage,
 *   beforeLoad: createAuthGuard()
 * });
 * ```
 */
export function createAuthGuard() {
  return () => {
    const auth = getAuthSnapshot();

    // If user is already authenticated, redirect to their dashboard
    if (auth.isAuthenticated && auth.slug) {
      throw redirect({
        to: '/$slug',
        params: { slug: auth.slug }
      });
    }
  };
}
